import Alpine from "alpinejs";
import {Arrows} from "@splidejs/splide/src/js/components";


function debounce(func, delay) {
    let timerId;

    return function (...args) {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

Alpine.data('lettersList', () => ({
    search: '',
    results: [],
    showItem(el) {
        return this.search === '' || el.dataset.search && el.dataset.search.split(',').find((v) => v.toLowerCase().trim().includes(this.search.toLowerCase()));
    },

    highlightItem(el) {
        if (this.search === '') {
            el.innerHTML = el.innerText
        } else {
            el.innerHTML = el.innerText.replace(new RegExp(this.search + '(?!([^<]+)?<)', 'gi'),
                '<mark>$&</mark>'
            );
        }
        return el
    },

    init() {
        const isElementInViewport = (el) => {
            const rect = el.getBoundingClientRect();

            return (
                rect.top >= 100 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            );
        }

        let linksList = Array.from(this.$root.querySelectorAll('[href*="glossar-"]'));
        let linkListWrapper = linksList[0].parentNode.parentNode;
        let linkListFirstElement = Array.from(linkListWrapper.querySelectorAll('li'))[0];
        let definitionList = Array.from(this.$root.querySelectorAll('[id*="glossar-"]'));
        let headerHeight = document.querySelector('header').getBoundingClientRect().height;

        window.addEventListener('scroll', (e) => {
            if (e.target !== document) return;

            // over first element -> scroll to first, even if it is inactive/disabled.
            if (linkListWrapper.getBoundingClientRect().top > headerHeight) {
                window.dispatchEvent(new CustomEvent('onlinkhighlight', {detail: {el: linkListFirstElement}}))
            }

            let definition = definitionList.find(_el => isElementInViewport(_el));

            linksList.map(el => {
                if (definition && definition.id && el.getAttribute('href').toLowerCase() === ('#' + definition.id.toLowerCase())) {
                    if (!el.parentNode.classList.contains('active')) {
                        window.dispatchEvent(new CustomEvent('onlinkhighlight', {detail: {el: el.parentNode}}))
                        el.parentNode.classList.add('active');
                    }
                } else {
                    el.parentNode.classList.remove('active');
                }
            });
        }, true);

        window.addEventListener('onlinkhighlight', e => linkListWrapper.scrollTo({
            top: 0,
            left: linkListWrapper.scrollLeft + e.detail.el.getBoundingClientRect().left - 62,
            behavior: "smooth",
        }));

        window.addEventListener('click', (e) => {
            if (!e.target.href) return;
            let offsetHeight = headerHeight + linkListWrapper.getBoundingClientRect().height + 20;
            let target = definitionList.find(el => e.target.getAttribute('href').toLowerCase() === ('#' + el.id.toLowerCase()));

            if (target) {
                e.preventDefault();
                e.stopPropagation();

                setTimeout(() => {
                    window.scrollTo({
                        top: target.getBoundingClientRect().top + window.scrollY - offsetHeight,
                        left: 0,
                        behavior: "smooth",
                    });
                }, 1);
            }
        });

        this.$root.querySelectorAll('.arrow').forEach(el => new Arrow(el, this.$root));
    },

    isResults() {
        this.results = []
        let linksList = Array.from(this.$root.querySelectorAll('[id*="glossar-"]'));

        linksList.forEach(el => {
            if (this.search === '' || el.dataset.search && el.dataset.search.split(',').find((v) => v.toLowerCase().trim().includes(this.search.toLowerCase()))) {
                this.results.push(el);
            }
        });

        return !this.results.length;
    }
}));


class Arrow {
    #class = {
        menu: 'letter-list__wrapper',
        arrow: {
            wrapper: 'arrows',
            left: 'arrow--is-left',
            right: 'arrow--is-right',
            active: 'arrow--is-active'
        }
    }

    constructor(arrowElement, parentElement) {
        if (!arrowElement || !parentElement) return;
        this.arrowElementNode = arrowElement;
        this.menuNode = parentElement.querySelector(`.${this.#class.menu}`);
        this.type = this.arrowElementNode.classList.contains(this.#class.arrow.left) ? 'left' : 'right'
        this.direction = this.type === 'left' ? -1 : 1;
        this.toggle();
        this.isVisible = this.arrowElementNode.classList.contains(this.#class.arrow.active);

        window.addEventListener('click', e => {
            if (this.arrowElementNode.contains(e.target) || e.target === this.arrowElementNode) {
                this.scrollMenu(this.direction);
            }
        });

        this.menuNode.addEventListener('scroll', e => {
            this.toggle();
        });
    }

    toggle() {
        let menu = this.menuNode;
        let menuRect = menu.getBoundingClientRect();
        let isEdgeLeft = this.type === 'left' && menu.scrollLeft <= 12;
        let isEdgeRight = this.type === 'right' && menu.scrollWidth - menu.scrollLeft - menuRect.width <= 12
        this[isEdgeLeft || isEdgeRight ? 'hide' : 'show']();
    }

    show() {
        if (this.isVisible) return;
        this.isVisible = true;
        this.arrowElementNode.setAttribute('tabindex', this.tabindex);
        this.arrowElementNode.classList.add(this.#class.arrow.active);
    }

    hide() {
        if (!this.isVisible) return;
        this.isVisible = false;
        this.tabindex = this.arrowElementNode.getAttribute('tabindex') || -1;
        this.arrowElementNode.setAttribute('tabindex', -1);
        this.arrowElementNode.classList.remove(this.#class.arrow.active);
    }

    scrollThreshold() {
        let menu = this.menuNode;
        let menuRect = menu.getBoundingClientRect();

        return menu.scrollWidth - menuRect.width;
    }

    scrollMenu(direction) {
        direction = direction || 1;
        this.menuNode.scrollTo(this.menuNode.scrollLeft + this.scrollThreshold() * direction, 0);
    }
}
